import React from "react";
import { useVerification } from "../../../../../context/Verification.context";
import { ArtifactStyle } from "./VerficationArtifactsStyles";
import { Box, Typography } from "@mui/material";

const TextUnAvailable = (args) => {
  const { text, es_text } = args;
  const verification = useVerification();
  return (
    <Box>
      {verification.aiData.spanish ? (
        es_text ? (
          <pre style={ArtifactStyle.textBox}>{es_text}</pre>
        ) : (
          <Typography variant="h6" textAlign={"center"}>
            No Spanish version available
          </Typography>
        )
      ) : text ? (
        <pre style={ArtifactStyle.textBox}>{text}</pre>
      ) : (
        <Typography variant="h6" textAlign={"center"}>
          No English version available
        </Typography>
      )}
    </Box>
  );
};

export default TextUnAvailable;
